export default {
    notify: {
        title: 'Уведомления',
        approvalPerson: {
            one: 'У вас 1 новый человек на согласование',
            few: 'У вас %(count)s новых человека на согласование',
            many: 'У вас %(count)s новых человек на согласование'
        },
        approvalProject: {
            one: 'У Вас 1 новая вакансия на согласование',
            few: 'У Вас %(count)s новые вакансии на согласование',
            many: 'У Вас %(count)s новых вакансий на согласование'
        },
        notDone: {
            one: 'У Вас 1 новое событие в списке "Что не сделано"',
            few: 'У Вас %(count)s новых события в списке "Что не сделано"',
            many: 'У Вас %(count)s новых событий в списке "Что не сделано"'
        },
        emptyList: 'У вас нет новый уведомлений',
        pushTitle: {
            person: 'Согласование людей',
            notdone: 'События на сегодня',
            project: 'Согласование вакансий',
        },
        toolTip: {
            notDone: 'Событий запланированно: %(notDoneCount)s',
            events: 'Уведомление за час до события',
        },
        errors: {
            permission: 'Включите уведомления в настройках браузера.',
        }
    },
    notificationPermission: 'Разрешение на устройстве',
    notificationUnsupported: 'Не поддерживаются на вашем устройстве/браузере',
    subscriptionStatus: 'Статус подписки',
    subscriptionEnable: 'Включить',
    subscriptions: 'Подписки:',
    options: {
        notifyProjectsEnabled: 'Согласование вакансий',
        notifyPersonEnabled: 'Согласование людей',
        notifyNotDoneEnabled: 'События на сегодня',
        notifyEventEnabled: 'События',
        notifyChangeRequestStatusEnabled: 'Заявки',
    },
}
